import Skeleton from 'react-loading-skeleton';

/**
 * Renders the loading placeholder for one inbox row, laying out a left and a right container each holding two full-height skeleton blocks. Takes no props, so every placeholder row is identical.
 *
 * @returns The skeleton markup for a single inbox list row.
 */
const InboxItemSkeleton = () => (
  <div className="inbox-item-skeleton-container">
    <div className="left-container">
      <div>
        <Skeleton height="100%" />
      </div>

      <div>
        <Skeleton height="100%" />
      </div>
    </div>

    <div className="right-container">
      <div>
        <Skeleton height="100%" />
      </div>

      <div>
        <Skeleton height="100%" />
      </div>
    </div>
  </div>
);

export default InboxItemSkeleton;
